import { Formatters, Messages } from '../../codegen/Localize';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import {
  ActionDialogBodyWithInlineErrorMessage,
  ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState
} from '../../commonInfra/dialogs/ActionDialogBodyWithInlineErrorMessage';
import { openReactActionDialog } from '../../commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { IIdItemInfo } from '../models/resourceInfoParts';
import { Set } from '../models/Set';
import { RemoteRefreshSchedules } from '../resources/RemoteRefreshSchedules';

const initialDialogState: ActionDialogBodyWithInlineErrorMessageState = {
};

export namespace DeleteRemoteRefreshSchedulesAction {

  export function execute(item: IIdItemInfo,
      selected: Set<IRemoteRefreshScheduleInfo>): Promise<IResult> {
    const confirmDeleteRemoteRefreshSchedulesMessage = Messages.confirmDeleteRemoteRefreshSchedules({ COUNT: selected.size() , COUNT_LOC: Formatters.formatCount(selected.size())});
    const initialBodyProps: ActionDialogBodyWithInlineErrorMessageProps = {dialogMessage: confirmDeleteRemoteRefreshSchedulesMessage};
    const dialogInstance = openReactActionDialog({
      title: Messages.deleteMessage(),
      actionName: Messages.confirmDeleteButton({ITEM_COUNT: selected.size(), ITEM_COUNT_LOC: Formatters.formatCount(selected.size())}),
      action: (_, state, updateDialogState) => {
        return RemoteRefreshSchedules.del(item.id, selected)
          .then((result: IResult) => {
            if (result.errors && result.errors.length) {
              const errorMessage = errorMessageFor(result.errors[0]);
              updateDialogState({errorMessage: errorMessage});
            } else {
              ContentActionNotification.displaySuccessToast(
                Messages.deleteRemoteRefreshScheduleSuccess({ITEM_COUNT: selected.size(), ITEM_COUNT_LOC: Formatters.formatCount(selected.size())}));
            }
            return result;
          });
      },
      isActionDelete: true,
      dialogWidth: TabDialogWidth.width375px,
      bodyComponent: ActionDialogBodyWithInlineErrorMessage,
      dismissDialogOnActionFailed: false,
      initialBodyProps,
      initialDialogState
    });

    return Promise.resolve(dialogInstance.result);

  }

  function errorMessageFor(error: IError) {
    return Messages.errorUnknown();
  }

}

export type DeleteRemoteRefreshSchedulesAction = typeof DeleteRemoteRefreshSchedulesAction;
